import { render, staticRenderFns } from "./ScreeningForCancer.vue?vue&type=template&id=a4ee6968&"
import script from "./ScreeningForCancer.vue?vue&type=script&lang=js&"
export * from "./ScreeningForCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports